import {createSlice,createAsyncThunk} from "@reduxjs/toolkit";
import axios from 'axios'

const data = {
        token:"",
        auth:false,
        email:"user@gmail.com",
        password:"#########" 
        };

const authSlice = createSlice({
name:'auth', 
initialState:{ 
    loading: false,
    user :data
},
reducers:{
    login:(state,action)=>{
        state.user = action.payload;
    },
    logout:(state)=>{
        state.user = {
            token:"",
            auth:false,
            email:"user@gmail.com",
            password:"#########"
        }
    }
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(fetchCurrentUser.pending, (state) => {
    //         state.loading = true;
    //         state.error = null;
    //         })
    //         .addCase(fetchCurrentUser.fulfilled, (state, action) => {
    //         state.loading = false;
    //         state.user = action.payload;
    //         })
    //         .addCase(fetchCurrentUser.rejected, (state, action) => {
    //         state.loading = false;
    //         state.error = action.error.message;
    //         });
    //     },
})

export const {login,logout} = authSlice.actions;
export default authSlice.reducer;